import React from 'react';
import useHasRiskResults from 'src/app/portfolio/views/global-nature-risk/hooks/useHasRiskResults';
import { ProductKey } from 'src/shared/types/engine/products';
import ProductGate from 'src/shared/components/product-gate/ProductGate';

type GlobalNatureRiskGateProps = {
    /** The page a pitched user sees. Without it, a pitched user gets page-not-found. */
    upsell?: React.ReactNode;
    children: React.ReactNode;
};

/** `ProductGate` for Global Nature Risk, which has results when the organisation has assessed sites. */
const GlobalNatureRiskGate = ({ upsell, children }: GlobalNatureRiskGateProps) => {
    const hasRiskResults = useHasRiskResults();

    return (
        <ProductGate product={ProductKey.GLOBAL_NATURE_RISK} hasResults={hasRiskResults} upsell={upsell}>
            {children}
        </ProductGate>
    );
};

export default GlobalNatureRiskGate;
